<template lang="pug">
  .rating-star
    svg-icon(class="icon-star" :style="styleSize" :icon="firstStar")
    svg-icon(class="icon-star" :style="styleSize" :icon="secondtStar")
    svg-icon(class="icon-star" :style="styleSize" :icon="thirdStar")
    svg-icon(class="icon-star" :style="styleSize" :icon="fourthStar")
    svg-icon(class="icon-star" :style="styleSize" :icon="fifthStar")
</template>

<style lang="scss" scoped>
.rating-star {
  .icon-star {
    margin: 0 2px;
    display: inline-flex;
  }
}
</style>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
  computed: {
    styleSize() {
      return { width: `${this.size}px`, height: `${this.size}px` }
    },
    firstStar: function () {
      return this.iconClassName(1)
    },
    secondtStar: function () {
      return this.iconClassName(2)
    },
    thirdStar: function () {
      return this.iconClassName(3)
    },
    fourthStar: function () {
      return this.iconClassName(4)
    },
    fifthStar: function () {
      return this.iconClassName(5)
    },
  },
  methods: {
    iconClassName(position) {
      if (position <= this.rating) {
        return 'star-active'
      } else if (position - 0.5 <= this.rating) {
        return 'star-harf'
      }
      return 'star-inactive'
    },
  },
}
</script>
